import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  MDBCard,
  MDBCardBody,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBBtn,
  MDBCollapse,
} from "mdbreact";
import SummaryLoading from "./loading";
import { Services } from "../../../../../../../services/fakeDb";
import Modal from "../modal";
import {
  TOGGLE,
  RESET,
} from "../../../../../../../services/redux/slices/finance/bookkeeping/remittances";

export default function Vouchers() {
  const {
      collections,
      total,
      dealsLoading: isLoading,
    } = useSelector(({ deals }) => deals),
    { isDeclaredFC = false } = useSelector(({ remittances }) => remittances),
    [menuCensus, setMenuCensus] = useState([]),
    [serviceCensus, setServiceCensus] = useState([]),
    [breakdown, setBreakdown] = useState({}),
    [activeTab, setActiveTab] = useState("menus"),
    [show, setShow] = useState(false),
    [isDeclarigFC, setIsDeclarigFC] = useState(false),
    [selectedCensus, setSelectedCensus] = useState({}),
    [remittance, setRemittance] = useState({}),
    dispatch = useDispatch();

  const toggle = useCallback(() => setShow(!show), [show]);

  const getFloatingCash = () => {
    const fcString = localStorage.getItem("floatingcash");
    if (fcString) return JSON.parse(fcString);
    return {};
  };

  const handleSummary = useCallback(
    (selected) => {
      if (selected?._id) {
        const menus = menuCensus.reduce((acc, { _id, count }) => {
          acc[_id] = count;
          return acc;
        }, {});

        const data = {
          _id: selected._id,
          census: {
            menus,
            services: serviceCensus,
          },
          breakdown,
          patient: collections.length,
          gross: total,
        };

        setRemittance(selected);
        setSelectedCensus(data);
        toggle();
      }
    },
    [menuCensus, serviceCensus, breakdown, collections, total, toggle]
  );

  useEffect(() => {
    if (isDeclarigFC && isDeclaredFC) {
      //to automatic toggle the modal of closing cash after declaring the floating cash
      handleSummary(getFloatingCash());
      setIsDeclarigFC(false);
      dispatch(RESET());
    }
  }, [isDeclarigFC, isDeclaredFC, dispatch, handleSummary]);

  useEffect(() => {
    if (collections && collections.length > 0 && !isLoading) {
      const menuCountMap = {};
      const serviceCountMap = {};
      const paymentSummary = {};

      collections.forEach(({ cart, amount, payment, refNo }) => {
        const { careOf = {}, amount: debtAmount, pp = "cash" } = refNo || {};
        if (payment && amount) {
          const isMixed = payment === "mixed";
          const isVoucher = payment === "voucher";

          const basePayment = isVoucher
            ? "voucher"
            : isMixed //because in mixed we have a gcash and cash
            ? refNo.pp
            : payment;

          const baseAmount = isVoucher || isMixed ? debtAmount || 0 : amount;

          paymentSummary[basePayment] =
            (paymentSummary[basePayment] || 0) + baseAmount;

          if (isMixed && careOf.pp === "gcash") {
            //for split(2) GCASH
            paymentSummary.gcash =
              (paymentSummary.gcash || 0) + (careOf.amount || 0);
          }

          if (careOf.pp === "co") {
            //for care off add the amount in vouchers
            paymentSummary.voucher =
              (paymentSummary?.voucher || 0) + (careOf?.amount || 0);
          }

          if (isVoucher && pp === "cash") {
            //for voucher
            paymentSummary.cash =
              (paymentSummary?.cash || 0) + (amount - debtAmount || 0);
          }
        }

        cart?.forEach(({ menuId, packages }) => {
          const { _id, abbreviation } = menuId;
          if (!menuCountMap[_id]) {
            menuCountMap[_id] = { _id, abbreviation, count: 0 };
          }
          menuCountMap[_id].count += 1;

          packages.forEach((id) => {
            if (!serviceCountMap[id]) {
              serviceCountMap[id] = 0;
            }
            serviceCountMap[id] += 1;
          });
        });
      });
      setBreakdown(paymentSummary);
      setMenuCensus(Object.values(menuCountMap));
      setServiceCensus(serviceCountMap);
    }
  }, [collections, isLoading]);

  const handleSubmit = () => {
    const _selected = getFloatingCash();
    if (!_selected?._id) {
      dispatch(
        TOGGLE({
          key: "open",
          value: new Date().getDate(),
          seleted: {},
          description:
            "Looks like you haven't set your floating cash yet. Go ahead and declare it now!",
        })
      );
      setIsDeclarigFC(true);
    } else {
      handleSummary(_selected);
    }
  };

  return (
    <MDBCard className="shadow-sm">
      <MDBCardBody>
        <h6 className="text-uppercase font-weight-bold text-primary text-center ">
          End-of-Shift Summary
        </h6>

        <MDBNav pills color="primary" className="nav-justified">
          <MDBNavItem>
            <MDBNavLink
              to="#!"
              active={activeTab === "menus"}
              onClick={() => setActiveTab("menus")}
            >
              Menus
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink
              to="#!"
              active={activeTab === "services"}
              onClick={() => setActiveTab("services")}
            >
              Services
            </MDBNavLink>
          </MDBNavItem>
        </MDBNav>

        {/* Menus Tab */}
        <MDBCollapse isOpen={activeTab === "menus"}>
          <MDBCardBody>
            {!isLoading ? (
              menuCensus.length > 0 ? (
                <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                  <ul className="list-group mb-3">
                    {menuCensus.map(({ _id, abbreviation, count }) => (
                      <li
                        key={_id}
                        className="list-group-item d-flex justify-content-between py-1"
                      >
                        <span>{abbreviation}</span>
                        <strong className="text-primary">{count}</strong>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <p className="text-muted">No menu items found.</p>
              )
            ) : (
              <SummaryLoading />
            )}
          </MDBCardBody>
        </MDBCollapse>

        {/* Services Tab */}
        <MDBCollapse isOpen={activeTab === "services"}>
          <MDBCardBody>
            {!isLoading ? (
              Object.keys(serviceCensus).length > 0 ? (
                <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                  <ul className="list-group mb-3">
                    {Object.entries(serviceCensus).map(([key, count], idx) => (
                      <li
                        key={idx}
                        className="list-group-item d-flex justify-content-between py-1"
                      >
                        <span>
                          {Services.getAbbr(key) || `Service #${key}`}
                        </span>
                        <strong className="text-primary">{count}</strong>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <p className="text-muted">No services found.</p>
              )
            ) : (
              <SummaryLoading />
            )}
          </MDBCardBody>
        </MDBCollapse>

        {collections.length > 0 && (
          <MDBBtn
            className="w-100"
            color="primary"
            size="sm"
            onClick={handleSubmit}
            disabled={menuCensus.length === 0 || isLoading}
          >
            <strong>Submit</strong>
          </MDBBtn>
        )}
      </MDBCardBody>
      <Modal
        selected={selectedCensus}
        toggle={toggle}
        show={show}
        remittance={remittance}
      />
    </MDBCard>
  );
}
